import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PerformanceInfoData } from '@features/models/performance-info-data';
import { ProductionGameDetailsData } from '@features/games/models/production-game-details-data';
import { GameRatingService } from '@features/games/services/game-rating.service';
import { ProductionGamePageService } from '@features/games/services/production-game-page.service';
import { GameRatingData } from '@features/games/models/game-rating-data';

@Component({
  selector: 'app-production-game-rate',
  imports: [CommonModule],
  templateUrl: './production-game-rate.component.html',
  styleUrl: './production-game-rate.component.scss'
})
export class ProductionGameRateComponent {

  private productionGamePageService = inject(ProductionGamePageService);
  private gameRatingService = inject(GameRatingService);

  public gameDetails?: ProductionGameDetailsData;
  public gameRatingList?: GameRatingData[];
  public performanceList?: PerformanceInfoData[];

  ngOnInit(): void {
    this.productionGamePageService.page$.subscribe(page => {
      this.performanceList = page?.productionDetails?.performanceList?.sort((a: PerformanceInfoData, b: PerformanceInfoData) => (a.sequenceNo ?? 0) - (b.sequenceNo ?? 0));
    });

    this.gameRatingService.gameRatingList$.subscribe(gameRatingList => {
      this.gameRatingList = gameRatingList;
    })
  }

  public getPerformance(performanceId?: string): PerformanceInfoData | undefined {
    return this.performanceList?.find(performance => performance.performanceId == performanceId);
  }

  public getGameRating(performanceId?: string): GameRatingData | undefined {
    return this.gameRatingList?.find(gameRating => gameRating.performanceId == performanceId);
  }

  public ratePerformance(performanceId: string | undefined, rating: string) {
    console.log(performanceId, rating);
    
    if (this.gameRatingList && performanceId) {
      var performanceRating = this.getGameRating(performanceId);
      if (performanceRating?.rating !== rating) {

        if (performanceRating !== undefined) {
          performanceRating.rating = rating;
        }
        else {
          performanceRating = {
            performanceId: performanceId,
            rating: rating
          };

          this.gameRatingList.push(performanceRating);
        }

        this.gameRatingService.setRating(performanceRating);
      }
    }
  }

}
